/**
 * 利用申込書(C)
 */
import Vue from 'vue'
import * as httpConst from '../../../../../constants/httpConst'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/masters/tenants/jwnet_edi_application_forms`

const jwnet_edi_application_form = {
namespaced: true,
actions: {
  show ({ commit }, { params }) {
    return new Promise((resolve) => {
      Vue.$http.get(API_PATH, { params: params }).then(data => {
        resolve(data.content)
      })
    })
  },
},
}
export default jwnet_edi_application_form
